export enum CUSTOMER_LOGO_GRID_SIZE {
  SM = 'sm',
  MD = 'md',
}
